import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

import 'lib-flexible/flexible'
//全局样式
import './plugins/baseStyle.less'
import './plugins/vant'

import https from './http/index.js'
Vue.prototype.$http = https;//接口

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
